<template>
  <transition name="el-fade-in-linear">
  <div v-show="transitionshow">
  	  <div class="backborder3"> 
	      <el-form ref="update" :model="update" :rules="rules" label-width="100px" size="small">
	          <el-col :span="24">
	          	  <el-col :span="8">
	          	  	  <el-form-item label="帐户名称" prop="name">
	                  	  <el-input v-model="update.name"></el-input>
	                  </el-form-item>
	          	  </el-col>
	          </el-col>
	          <el-col :span="24">
	          	  <el-col :span="8">
	          	  	  <el-form-item label="编号" prop="number">
		                  <el-input v-model="update.number"></el-input>
		              </el-form-item>
	          	  </el-col>
	          </el-col>
	          <el-col :span="24">
	          	  <el-col :span="8">
	          	  	  <el-form-item label="户名">
		                  <el-input v-model="update.truename"></el-input>
		              </el-form-item>
	          	  </el-col>
	          </el-col>
	          <el-col :span="24">
	          	  <el-col :span="8">
	          	  	  <el-form-item label="帐号">
		                  <el-input v-model="update.account"></el-input>
		              </el-form-item>
	          	  </el-col>
	          </el-col>
	      </el-form>
          <div slot="footer" class="dialog-footer" style="text-align:right">
            <el-button size="small" type="primary" :loading="updateLoading" @click="updateSave">保 存</el-button>
          </div>
      </div>
  </div>
  </transition>   
</template>

<script>

export default {
  props:['childdata'],
  data () {
    return {
      actionauth:'', //操作功能权限
      transitionshow:true,
      url:this.GLOBAL.domain+"Account/index",
      update: {
        act:'edit',
        token:this.$cookies.get('token'),
        id:'',
        name:'',
        number:'',
        truename:'',
        account:''
      },
      updateLoading:false,
      rules: {
        name: [
            { required: true, message: '请输入银行帐户名称', trigger: 'blur' },
            { min: 2, max: 20, message: '长度在 2 到 20 个字符'}
        ],
        number: [
            { required: true, message: '请输入编号', trigger: 'blur' },
            { min: 1, max: 8, message: '长度在 1 到 8 个字符'},
            { pattern:/^[A-Za-z0-9]+$/, message: '编号只能为字母和数字'}
        ]
      }
      
    }
  },
  mounted(){
    this.getactionauth();
    this.editCurrent(); //获取银行账户信息
  },
  methods:{
  
    /** 获取操作功能权限 **/
  	getactionauth() {
    	var data =this.$cookies.get('actionauth');
    	data=JSON.parse(data);
        this.actionauth=data;
    },
    
    editCurrent() {
    	this.update.id=this.childdata.id;
        this.update.name=this.childdata.name;
        this.update.number=this.childdata.number;
        this.update.truename=this.childdata.truename;
        this.update.account=this.childdata.account;
    },
    
    updateSave(){
      // 主动校验
      this.$refs.update.validate((valid) => {
          if (valid) {
              this.updateLoading=true;
              var resource = this.$resource(this.url);
              resource.save(this.update).then((res) => {
                  if(res.data.Result>0){
                    if(res.data.Result=='70001') this.$router.push('/login')
                    this.$message.error(res.data.Message);
                    this.updateLoading=false;
                  }else{
                    this.$message.success(res.data.Message);
                    this.updateLoading=false;
                    this.$emit('closechild','Accountedit'); //关闭窗口
                  }
              }).catch((res) => {
                  this.$message.error(this.GLOBAL.errortext);
                  this.updateLoading=false;
              });
          }else {
            return false;
          }
      });
    },
  	
    
  }
}
</script>
<style>
.backborder1 {background:#fff;border-radius:15px;border:1px solid #ddd;padding:1% 1% 0 1%}
.backborder3 {background:#fff;border-radius:15px;border:1px solid #ddd;padding:1% 1% 3% 1%}
</style>


// WEBPACK FOOTER //
// src/components/base/Accountedit.vue